import { mapValues, pick } from 'lodash/fp';

import { ModalField } from '../../types';

type GetFormValuesFromUrlParams<T> = {
  hasInputComponent: boolean;
  hasInputDataLoaded: boolean;
  destinationLocation?: string;
  modalFields: ModalField[];
  queryStringValues: Partial<T>;
  initialValues: Partial<T>;
  getCustomParamValues?: () => Record<string, any>;
};

const convertToBoolean = (value: string) => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return value;
};

const getFormValuesFromUrl = <T>({
  getCustomParamValues,
  hasInputComponent,
  hasInputDataLoaded,
  initialValues,
  modalFields,
  queryStringValues = {},
}: GetFormValuesFromUrlParams<T>): Partial<T> | null => {
  if (hasInputComponent && !hasInputDataLoaded) {
    return null;
  }

  const formFieldNames = modalFields.map(({ fields }) => fields).flat();
  const convertedQueryStringValues = mapValues(convertToBoolean, queryStringValues);
  const widgetValuesFromQuery = pick(formFieldNames, convertedQueryStringValues) as Partial<T>;
  const valuesFormattedToMatchForm = getCustomParamValues ? getCustomParamValues() : {};
  return { ...initialValues, ...widgetValuesFromQuery, ...valuesFormattedToMatchForm };
};

export default getFormValuesFromUrl;
